var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.minutes || _setup.seconds !== '00')?_c('div',{staticClass:"flex flex-row align-center"},[_vm._t("before-time"),_c('p',{class:`text-${_vm.color}-${_vm.intensity}`},[_vm._v(_vm._s(_setup.minutes)+":"+_vm._s(_setup.seconds))]),_vm._t("after-time")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }